export default {
  active: 'You are a member for %{semester} %{year}',
  keyInfo: 'Do you want a key to the basement? See more info on our wiki:',
  inactive:
    'You have not paid the members fee. If you just paid recently, this status will be updated shortly.',
  logout: 'Log out',
};
